// extracted by mini-css-extract-plugin
export default {"m":"BadgeItem_m__1BEyu","l":"BadgeItem_l__ruv96"};